import { Form, Input } from "decorator-form";
import InputType from "../../common/form/InputType";

@Form({title: "Page Link"})
export default class PageLinkConfig {

	@Input({type: InputType.TEXT, title: "Link Text"})
	public linkText: string;

}



// WEBPACK FOOTER //
// ./src/panels/pageLink/PageLinkConfig.ts